// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { ElevatorTrafficMessage, ElevatorTrafficMessageT } from "./elevator-traffic-message";
import { EscalatorTrafficMessage, EscalatorTrafficMessageT } from "./escalator-traffic-message";

export enum DeviceTrafficMessage {
  NONE = 0,
  ElevatorTrafficMessage = 1,
  EscalatorTrafficMessage = 2,
}

export function unionToDeviceTrafficMessage(
  type: DeviceTrafficMessage,
  accessor: (
    obj: ElevatorTrafficMessage | EscalatorTrafficMessage,
  ) => ElevatorTrafficMessage | EscalatorTrafficMessage | null,
): ElevatorTrafficMessage | EscalatorTrafficMessage | null {
  switch (DeviceTrafficMessage[type]) {
    case "NONE":
      return null;
    case "ElevatorTrafficMessage":
      return accessor(new ElevatorTrafficMessage())! as ElevatorTrafficMessage;
    case "EscalatorTrafficMessage":
      return accessor(new EscalatorTrafficMessage())! as EscalatorTrafficMessage;
    default:
      return null;
  }
}

export function unionListToDeviceTrafficMessage(
  type: DeviceTrafficMessage,
  accessor: (
    index: number,
    obj: ElevatorTrafficMessage | EscalatorTrafficMessage,
  ) => ElevatorTrafficMessage | EscalatorTrafficMessage | null,
  index: number,
): ElevatorTrafficMessage | EscalatorTrafficMessage | null {
  switch (DeviceTrafficMessage[type]) {
    case "NONE":
      return null;
    case "ElevatorTrafficMessage":
      return accessor(index, new ElevatorTrafficMessage())! as ElevatorTrafficMessage;
    case "EscalatorTrafficMessage":
      return accessor(index, new EscalatorTrafficMessage())! as EscalatorTrafficMessage;
    default:
      return null;
  }
}

export type DeviceTrafficMessageT =
  | { type: "NONE"; value: null }
  | { type: "ElevatorTrafficMessage"; value: ElevatorTrafficMessageT }
  | { type: "EscalatorTrafficMessage"; value: EscalatorTrafficMessageT };
